/**
 * Clustersie Sites Index
 * 
 * Simple standalone site components configuration
 */

/**
 * Site Mapping
 * Maps subdomain keys to their respective components
 */
export const siteMapping = {
  main: 'MainSite',
  coffee: 'CoffeeSite',
  fisheries: 'FisheriesSite',
  fruit: 'FruitSite',
  bittermelon: 'BitterMelonSite',
  halal: 'HalalSite',
  mulberry: 'MulberrySite'
}

/**
 * Available Sites List
 * For use in navigation and site selection
 */
export const availableSites = [
  { key: 'main', name: 'แพลตฟอร์มหลัก', icon: '🏢', color: 'green' },
  { key: 'coffee', name: 'คลัสเตอร์กาแฟ', icon: '☕', color: 'amber' },
  { key: 'fisheries', name: 'คลัสเตอร์ประมง', icon: '🐟', color: 'blue' },
  { key: 'fruit', name: 'คลัสเตอร์ผลไม้', icon: '🍎', color: 'orange' },
  { key: 'bittermelon', name: 'คลัสเตอร์มะระ', icon: '🥒', color: 'emerald' },
  { key: 'halal', name: 'คลัสเตอร์ฮาลาล', icon: '🥘', color: 'emerald' },
  { key: 'mulberry', name: 'คลัสเตอร์หม่อน', icon: '🫐', color: 'purple' }
]